// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/foundations/spacing.ts
export var space = {
  18: '4.5rem',
  50: '12.5rem'
};
//# sourceMappingURL=space.js.map